import { Shop, IShop } from '../models/shop.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ShopService {

  constructor(private http: HttpClient) {}

  getShop(): Observable<any> {

    return this.http.get<any>(`${environment.url}/shop/all`);
  }

  getAllShop(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/shop`+ (size ? '?page=' + page + '&size=' + size : ''), {'headers': headers});
  }

  getAllShopSearch(page: number, size: number, searchTerm?: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    let url = `${environment.url}/shop/search-shop?page=${page}&size=${size}`;
    if (searchTerm) {
      url += `&searchTerm=${searchTerm}`;
    }

    return this.http.get<any>(url, { headers: headers });
  }

  getShopKahpoo(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/kahpoo` , {'headers': headers});
  }

  query(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/shop/connected` + (size ? '?page=' + page + '&size=' + size : ''), {'headers': headers});
  }


  loardSellerShop(username : any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/shop/sellerusername/` + username, {'headers': headers});
  }

  getProductShop(Shop: IShop): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/product/postedByShop/` + Shop.id, {'headers': headers});
  }
  getServiceShop(Shop: IShop): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/service/postedByShop/` + Shop.id, {'headers': headers});
  }

  getShopBycurrentSearch(search: string, page: number, size: number) {
    return this.http.get<any>(`${environment.url}/shop` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size));
  }

  saveShop(Shop: IShop) {
    let headers = new HttpHeaders();
     headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/shop`, Shop, {'headers': headers});

  }

  getIdShop(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/shop/` + idA, {'headers': headers});
  }

  getIdShopID(shopID: any) {
    return this.http.get(`${environment.url}/shop/shopID/` + shopID);
  }

  kahpooShop() {
    return this.http.get(`${environment.url}/shop/kahpoo`);
  }

  updateShop(Shop: IShop) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/shop/` + Shop.id, Shop, {'headers': headers});
  }

  deleteShop(id: any) {
    return this.http.delete(`${environment.url}/shop/` + id);
  }

  // girl tech!!
  getShopByUser(idA: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/shop/user/` + idA, {'headers': headers});
  }

  getKahpooShopsByDate(startDate: any, endDate: any ,page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/shop/allKahpooshops?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
  }

  getShopByShopId(shopId:string){
    //api/shop/shopID/SPKMLWF6B4ES
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/shop/shopID/`+shopId,{'headers': headers});
  }

}
